import { combineReducers } from "redux";
import metricsData from "src/shared/models/ManageMetricsModel";
import { createReduxOperation } from "src/store/utils";
import { IManageMetricsRootState, ClearTypes, UpdateMetricsActionPayload } from "./types";
import * as api from "src/api/manageMetrics";
import { ThunkResult } from "src/shared/types";

const {
  actions: [manageMetricsFetchRequest, manageMetricsFetchSuccess, manageMetricsFetchFailure, manageMetricsFetchClear],
  reducer: manageMetricsFetchReducer,
} = createReduxOperation("FETCH_MANAGE_METRICS");

const {
  actions: [
    manageMetricsUpdateRequest,
    manageMetricsUpdateSuccess,
    manageMetricsUpdateFailure,
    manageMetricsUpdateClear,
  ],
  reducer: manageMetricsUpdateReducer,
} = createReduxOperation("UPDATE_MANAGE_METRICS");

export function clearManageMetrics(payload?: ClearTypes): ThunkResult<void> {
  return (dispatch) => {
    switch (payload) {
      case ClearTypes.FETCH:
        dispatch(manageMetricsFetchClear());
        break;
      case ClearTypes.UPDATE:
        dispatch(manageMetricsUpdateClear());
        break;
      default:
        dispatch(manageMetricsFetchClear());
        dispatch(manageMetricsUpdateClear());
    }
  };
}

export function fetchManageMetrics(): ThunkResult<Promise<void>> {
  return async (dispatch) => {
    dispatch(manageMetricsFetchRequest());
    const { response, error } = await api.getManageMetrics();
    if (response) {
      const manageMetrics = metricsData.createManageMetric(response);
      dispatch(manageMetricsFetchSuccess(manageMetrics));
    } else {
      dispatch(manageMetricsFetchFailure(error));
    }
  };
}

export function updateManageMetrics({
  data,
  switchBackToHome,
}: UpdateMetricsActionPayload): ThunkResult<Promise<void>> {
  return async (dispatch) => {
    dispatch(manageMetricsUpdateRequest());
    const apiPayload = metricsData.prepareAPICallData(data);
    const { response } = await api.updateManageMetrics(apiPayload);
    if (response && response.status === 200) {
      dispatch(manageMetricsUpdateSuccess());
      dispatch(clearManageMetrics());
      switchBackToHome();
    } else {
      dispatch(manageMetricsUpdateFailure("Something went wrong"));
    }
  };
}

export const manageMetricsReducer = combineReducers<IManageMetricsRootState>({
  fetchedManageMetrics: manageMetricsFetchReducer,
  updatedManageMetrics: manageMetricsUpdateReducer,
});

export { manageMetricsFetchClear, manageMetricsUpdateClear };
